export const linksDataFooterPSP = [
  {
    id: 1,
    name: "Group Booking Form",
    link: "https://www.cordeliacruises.com/group-booking",
  },
  {
    id: 2,
    name: "Agent Login",
    link: "https://agent.cordeliacruises.com/login",
  },
  {
    id: 3,
    name: "About Us",
    link: "https://www.cordeliacruises.com/about-us",
  },
  {
    id: 4,
    name: "Valet Services Mumbai",
    link: "https://images.cordeliacruises.com/static/valet_sevice.pdf",
  },
  {
    id: 5,
    name: "Ports",
    link: "https://images.cordeliacruises.com/static/Port%20Address.pdf",
  },
  {
    id: 6,
    name: "Website T&C",
    link: "https://images.cordeliacruises.com/static/Cordelia%20-Website%20Terms%20and%20Conditions.pdf",
  },
  {
    id: 7,
    name: "Contest T&C",
    link: "https://images.cordeliacruises.com/static/Contest_T&C.pdf",
  },
];

export const privacyAndPolicyFooterPSP = [
    {
      id: 1,
      name: "Privacy Policy",
      link: "https://www.cordeliacruises.com/privacy-policy",
    },
    {
      id: 2,
      name: "Onboard Policy",
      link: "https://www.cordeliacruises.com/onboard-policy",
    },
    {
      id: 3,
      name: "Heakth Waves Policy",
      link: "https://www.cordeliacruises.com/health-wave-policy",
    },
    {
      id: 4,
      name: "Clean Waves Policy",
      link: "https://www.cordeliacruises.com/clean-wave-policy",
    },
    {
      id: 5,
      name: "FAQ",
      link: "https://www.cordeliacruises.com/faqs",
    },
    {
      id: 6,
      name: "Terms & Conditions",
      link: "https://www.cordeliacruises.com/terms-condition",
    },
    {
      id: 7,
      name: "Passenger Cruise Ticket Contract",
      link: "https://images.cordeliacruises.com/cordelia_v2/public/pdf/Passenger+Cruise+Ticket+Contract.++POLICY+1+FINAL+2024+20.03.2024.pdf",
    },
    {
        id: 8,
        name: "Cruise SOP",
        link: "https://images.cordeliacruises.com/static/sop.PDF",
    },
    {
        id: 9,
        name: "Investor Relation",
        link: "https://www.cordeliacruises.com/investor-relation",
    },
    {
        id: 10,
        name: "User Agreement - Visa",
        link: "https://stampthepassport.com/cordelia-visapolicy",
    },
    {
        id: 11,
        name: "Privacy Policy - Visa",
        link: "https://stampthepassport.com/cordelia-visapolicy",
    },
  ];
